import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Neo둥근모 Pro';
    src: url('/fonts/NeoDunggeunmoPro-Regular.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Neo둥근모 Pro', sans-serif;
    background-color: #fff;
    color: #000;
    height: 100vh; /* 뷰포트 높이 맞춤 */
    overflow: hidden; /* 스크롤 제거 */
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  header, nav {
    background-color: #fff;
  }

  header h1, nav a {
    color: #000;
  }

  .icon {
    width: 24px;
    height: 24px;
    margin: 0 5px;
  }

  main.sc-jXbVAB.eKktB {
    width: 100%; /* 가로 폭을 100%로 설정 */
    max-width: 100%; /* 최대 너비를 설정하여 부모 요소의 크기를 조정 */
    margin: 0 auto; /* 가운데 정렬 */
  }

  div.sc-dhKdPU.eePcao {
    width: 100%; /* 폭을 넓힘 */
    max-width: 1400px; /* 최대 너비를 설정하여 부모 요소의 크기를 조정 */
    margin: 0 auto; /* 가운데 정렬 */
  }

  .izsXUg .kEnQEp .hOxfhR .fdRZAo {
    height: 95% !important; /* 세로 비율을 늘림 */
  }
`;

export default GlobalStyles;
